export default "__VITE_ASSET__Ddc0NtgX__"